<ng-container *ngIf="ticketModel">
  <div class="ticket-header">
    <div data-qa="organization-name">{{ ticketModel.orgTitle }}</div>
    <div data-qa="organization-iin">
      {{ 'organization.iin-bin' | translate }}: {{ ticketModel.orgId }}
    </div>
    <div data-qa="kkm-serial-number" *ngIf="ticketModel.kkmSerialNumber">
      {{ 'ticket.kkm.serial.number' | translate }}: {{ ticketModel.kkmSerialNumber }}
    </div>
    <div data-qa="kkm-rnm">{{ 'ticket.kkm.fns.id' | translate }} {{ ticketModel.kkmFnsId }}</div>
  </div>
  <div class="ticket-header">
    <div data-qa="ticket-description">
      <ng-container *ngFor="let item of ticketModel | ticketDescription; trackBy: trackByIndex">
        {{ item | translate }}
      </ng-container>
    </div>
    <ng-container *ngIf="ticketModel.ticket as ticket">
      <div data-qa="fiscal-id">
        {{ 'transaction.ticket.fiscal' | translate }}:
        {{
          ticket.offlineFiscalId
            ? ticket.offlineFiscalId + ' ' + ('transaction.ticket.offline' | translate)
            : ticket.fiscalId
        }}
      </div>
      <div *ngIf="ticket.operator.name as operatorName" data-qa="operator-name">
        {{ 'transaction.ticket.operator' | translate }}: {{ operatorName }}
      </div>
      <div data-qa="transaction-date">
        {{ ticket.transactionDate | date: 'dd.MM.yyyy / HH:mm' }}
      </div>
    </ng-container>
  </div>
</ng-container>
